@if (loading) {
    <app-loading [loading]="loading" />
} @else {
    <div class="container">
        <div class="tab-bar">
            <div class="tab-left flexRow aiC">
                {{ label | translate }}
            </div>
            <div class="tab-right flexRow aiC gap30">
                @if (isShowPreview) {
                    <app-people-preview
                        [data]="filteredPeople"
                    />
                }
            </div>
        </div>

        <div class="content">
            <app-complex-condition
                [formGroup]="conditions"
                [everyoneLabel]="everyoneLabel"
                [testID]="testID"
            />
        </div>
    </div>
}
